import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { KnowledgeTabs } from 'src/components/pages/ai-agents/components/knowledge-tabs';
import { DocumentSources } from 'src/components/pages/ai-agents/knowledge-base-sources/documents/document-sources';
import { LinkedKnowledgeBases } from 'src/components/pages/ai-agents/knowledge-base-sources/linked-knowledge-bases/linked-knowledge-bases';
import { WebsiteSources } from 'src/components/pages/ai-agents/knowledge-base-sources/websites/website-sources';

export const AiAgentKnowledgeSection = memo<{
  aiAgentId: string;
  knowledgeBaseId: string;
  sectionUrl: string;
}>(({ aiAgentId, knowledgeBaseId, sectionUrl }) => {
  const { t } = useTranslation(['aiAgents']);

  return (
    <KnowledgeTabs
      testId="ai-agent-knowledge-section"
      tabHeight={58}
      sourceContent={{
        websites: (
          <WebsiteSources knowledgeBaseId={knowledgeBaseId} aiAgentId={aiAgentId} />
        ),
        documents: (
          <DocumentSources knowledgeBaseId={knowledgeBaseId} aiAgentId={aiAgentId} />
        ),
      }}
      extraTabs={[
        {
          key: 'knowledgeBases',
          label: t('aiAgents:knowledge.tabs.knowledgeBases'),
          content: <LinkedKnowledgeBases aiAgentId={aiAgentId} sectionUrl={sectionUrl} />,
        },
      ]}
    />
  );
});
